import axios from "axios";

export const getEducationCareers = callback => {
  var promise = axios({
    method: "get",
    url: "/api/education_careers"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
